import { REAL_ESTATE_OBJECT_TYPES } from '@constants/definition'

const getObjectTitle = (object, t) => {
  if (!object) {
    return null
  }

  const params = {
    operation: object.apartmentOperation?.translation,
    room: object.roomCount,
    count: Number(object.roomCount || 0),
  }

  const locations = object.street
    ? [
        object.street?.city?.region?.country?.title,
        object.street?.city?.region?.title || object.alterAddress?.division?.title,
        object.street?.city?.title || object.alterAddress?.cityName,
        object.street?.title || object.alterAddress?.streetName,
        object.buildingNumber || object.alterAddress?.buildingNumber,
      ].filter((location) => !!location)
    : [
        object?.city?.country?.title,
        object?.city?.region?.title || object.alterAddress?.division?.title,
        object?.city?.title || object.alterAddress?.cityName,
      ].filter((location) => !!location)

  if (object.apartmentNumber || object.alterAddress?.apartmentNumber) {
    locations.push(
      t('object::title::apartmentNumber', {
        count: object.apartmentNumber || object.alterAddress?.apartmentNumber,
      })
    )
  }

  switch (object.apartmentType?.key) {
    case REAL_ESTATE_OBJECT_TYPES.HOUSE:
      return [t('object::title::house', { ...params, postProcess: 'interval' }), ...locations].join(
        ', '
      )

    case REAL_ESTATE_OBJECT_TYPES.COTTAGE:
      return [
        t('object::title::cottage', { ...params, postProcess: 'interval' }),
        ...locations,
      ].join(', ')

    case REAL_ESTATE_OBJECT_TYPES.GARAGE:
      return [t('object::title::garage', params), ...locations].join(', ')

    case REAL_ESTATE_OBJECT_TYPES.LAND:
      return [t('object::title::stead', params), ...locations].join(', ')

    case REAL_ESTATE_OBJECT_TYPES.BUSINESS:
      return [t('object::title::business', params), ...locations].join(', ')

    case REAL_ESTATE_OBJECT_TYPES.APARTMENT:
    default:
      return [
        t('object::title::apartment', { ...params, postProcess: 'interval' }),
        ...locations,
      ].join(', ')
  }
}
export { getObjectTitle }
